export function Settings() {
  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-2xl font-bold text-(--color-text-primary)">Configuración</h1>
        <p className="text-sm text-(--color-text-secondary) mt-1">Parámetros globales del sistema.</p>
      </div>
      <div className="flex items-center justify-center h-64 rounded-xl border border-dashed border-(--color-border) text-(--color-text-tertiary) text-sm">
        Módulo en desarrollo — Fase 5
      </div>
    </div>
  );
}
